import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSettings } from '../redux/actions/SettingActions';

// Singleton cache
let settingsCache = [];

// Exported utility to access setting values
export const getSettingValueById = (targetId) => {
  const item = settingsCache.find(entry => entry._id === targetId);
  return item ? item.value : null;
};

// React component to load and sync settings
const SettingsManager = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user?.token);
  const settings = useSelector((state) => state.setting.data?.settings || []);

  useEffect(() => {
    if (token) {
      dispatch(getAllSettings(token));
    }
  }, [token]);

  useEffect(() => {
    if (settings.length) {
      settingsCache = settings;
    }
  }, [settings]);

  return null; // This component doesn't render anything
};

export default SettingsManager;
